let sessionTimeout: number;

export const DefaultSessionTimeout = 20;
export const setSessionTimeout = (value: number) => (sessionTimeout = value);

/**
 * Gets the session timeout in minutes
 */
export const getSessionTimeout = () => sessionTimeout;
